import type { BoardTile } from '../../engine/board.js';
import type { MahjongRules } from '../../engine/rules.js';
import { standardRules } from '../../engine/rules.js';
import { turtleLayout } from './layouts/turtle.js';
import { pyramidLayout } from './layouts/pyramid.js';

export interface MahjongSpec {
  name: string;
  positions: ReadonlyArray<Omit<BoardTile, 'id'>>;
  rules: MahjongRules;
}

export function makeTurtleSpec(): MahjongSpec {
  return {
    name: 'Turtle',
    positions: turtleLayout,
    rules: standardRules,
  };
}

export function makePyramidSpec(): MahjongSpec {
  return {
    name: 'Pyramid',
    positions: pyramidLayout,
    rules: standardRules,
  };
}
